export function assertVisualClock(value: number, label: string): number {
  if (!Number.isFinite(value) || value < 0) {
    throw new RangeError(`${label} must be finite and non-negative`)
  }
  return value
}

export function fighterVfxFrame(dt: number, elapsedTime: number): { dt: number; elapsedTime: number } {
  return {
    dt: assertVisualClock(dt, 'frame delta'),
    elapsedTime: assertVisualClock(elapsedTime, 'elapsed time'),
  }
}
